import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  [types.BILLING_SUBSCRIPTION_CANCEL_REQUEST]: state => ({
    ...state,
    loading: true
  }),

  [types.BILLING_SUBSCRIPTION_CANCEL_DONE]: (state, { payload }) => ({
    ...state,
    data: payload,
    loading: false
  }),

  [types.BILLING_SUBSCRIPTION_CANCEL_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.BILLING_SUBSCRIPTION_CANCEL_RESET]: () => ({
    ...initialState
  })
};

export default function reducer(state = initialState, action) {
  const handler = actions[action.type];
  return handler ? handler(state, action) : state;
}
